import React from "react";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import PropTypes from "prop-types";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";

import {LOOK_OVERLAYS} from "../../../look/core/constants";
import {setLookAiImageExpanded, setLookAiImageOpened} from "../../aiActions";
import {setLookOverlayOpened, setLookReturnAction} from "../../../../actions/lookFunctions";
import {setUserPopupContent} from "../../../../actions/userFunctions";
import LookAIImageOverlayLoginContent from "./LookAIImageOverlayLoginContent";
import LookAIImageOverlayImageContent from "./LookAIImageOverlayImageContent";
import {IS_QKB_UI} from "../../../../config";


const LookAIImageOverlay = (props) => {

  const {lookOverlayOpened, lookAiImageOpened, lookAiVisited, showLeadOverlay, intl, setLookAiImageOpened, isMobile,
    showImagesListOverlay, setLookOverlayOpened, aiImageExpanded, setLookAiImageExpanded, aiResults} = props;

  if (!lookAiVisited) {
    return null;
  }

  const activeResult = aiResults.find(aiResult => aiResult.isActive);
  const opened = (lookOverlayOpened === LOOK_OVERLAYS.aiPanel) && lookAiImageOpened
    && !(!showLeadOverlay && activeResult && activeResult.conversionError);
  const hideImagesRoll = showLeadOverlay || isMobile || !showImagesListOverlay;

  const closeAIImageOverlay = () => {
    if (aiImageExpanded) {
      setLookOverlayOpened(""); // return sidebar button to be visible
    } else {
      setLookAiImageOpened(false);
      if (IS_QKB_UI && isMobile && showLeadOverlay) {
        setLookOverlayOpened(""); // return sidebar button to be visible
      }
    }
  }

  const expandAIImageOverlay = () => {
    setLookAiImageExpanded(!aiImageExpanded);
  }

  return (
    <div style={{left: (isMobile && showLeadOverlay) || aiImageExpanded
        ? IS_QKB_UI ? "1rem" : "5rem"
        : hideImagesRoll
          ? IS_QKB_UI ? "19rem" : "23.5rem"
          : IS_QKB_UI ? "37rem" : "41.5rem"}}
         className={"fixed transition2 look-ai__overlay top-1 right-1 bottom-1"
           + (IS_QKB_UI ? " look-ai__overlay--qkb" : "")
           + (!opened ? " opacity-0 visibility-hidden" : "")}>
      <div className={"bg-white flex flex--column flex--inline max-h-full p-1 rounded-025 z-10"
        + (showLeadOverlay ? " w-full h-full" : "")
        + (IS_QKB_UI ? " look-icon--with-shadow" : "")}>
        {showLeadOverlay
          ? <LookAIImageOverlayLoginContent/>
          : <LookAIImageOverlayImageContent opened={opened && !showLeadOverlay}/>}
        <div className="absolute flex flex--between flex--center left-175 right-175 top-175">
          <div>
            {showLeadOverlay ? null : (
              <IconButton aria-label={intl.formatMessage({id: "iconButton.more"})}
                          className="look-icon look-icon--small look-icon--white2 rounded-full"
                          onClick={expandAIImageOverlay}>
                <AspectRatioIcon className="h-125 w-125"/>
              </IconButton>
            )}
          </div>
          <div>
            <IconButton aria-label={intl.formatMessage({id: "iconButton.close"})}
                        className="look-icon look-icon--small look-icon--white2 rounded-full"
                        onClick={closeAIImageOverlay}>
              <CloseIcon/>
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  )
};

LookAIImageOverlay.propTypes = {
  showLeadOverlay: PropTypes.bool.isRequired,
  showImagesListOverlay: PropTypes.bool.isRequired,
}

const mapStateToProps = (store) => {
  const {lookOverlayOpened} = store.lookState;
  const {lookAiVisited, lookAiImageOpened, aiImageExpanded, aiResults} = store.aiState;
  const {isMobile} = store.serverState;

  return {
    lookOverlayOpened,
    lookAiVisited,
    lookAiImageOpened,
    isMobile,
    aiImageExpanded,
    aiResults,
  };
};

const mapDispatchToProps = {
  setLookAiImageOpened,
  setLookOverlayOpened,
  setLookReturnAction,
  setUserPopupContent,
  setLookAiImageExpanded,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookAIImageOverlay)
)
